import { render } from "./InjurySiteAlysis.vue?vue&type=template&id=b76f2b3c&scoped=true"
import script from "./InjurySiteAlysis.vue?vue&type=script&lang=js"
export * from "./InjurySiteAlysis.vue?vue&type=script&lang=js"

import "./InjurySiteAlysis.vue?vue&type=style&index=0&id=b76f2b3c&lang=scss&scoped=true"
import "./InjurySiteAlysis.vue?vue&type=style&index=1&id=b76f2b3c&lang=scss&scoped=true"
import "./InjurySiteAlysis.vue?vue&type=style&index=2&id=b76f2b3c&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b76f2b3c"]])

export default __exports__